import React, { useRef, useState } from "react";
import Header from "../../components/Header/Header";
import { Fade } from "react-awesome-reveal";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import "./ContactUs.css";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import emailjs from "@emailjs/browser";

export default function ContactForm(props: any) {
  const theme = props.theme;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const form: any = useRef();

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_f88l5s4",
        "template_o51krzc",
        form.current,
        "RaY3iFklqN89KQl5W"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Mail sent successfully!");
        },
        (error) => {
          console.log(error.text);
        }
      );

    setName("");
    setEmail("");
    setMessage("");
  };
  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div style={{ backgroundColor: "#fff" }} className="projects-main">
        <div className="BackgroundHome">
          <Header theme={theme} />
          <div className="basic-projects">
            <Fade duration={2000}>
              <section className="section section-lg section-shaped pb-250">
                <div className="shape shape-style-1 bg-gradient-info">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
                <div className="projects-heading-div">
                  <div className="projects-heading-img-div">
                    <DisplayLottie animationPath="/lottie/email.json" />
                  </div>
                  <div className="projects-heading-text-div">
                    <h1
                      className="projects-heading-text"
                      style={{ color: theme.white, marginBottom: "1rem" }}
                    >
                      Contact Us
                    </h1>
                    <p
                      className="projects-header-detail-text subTitle"
                      style={{ color: theme.white }}
                    >
                      Thank you for your interest in our projects! We would love
                      to hear from you and answer any questions you may have.
                      Whether you're interested in collaborating, have feedback,
                      or simply want to connect, please don't hesitate to reach
                      out to us.
                    </p>
                  </div>
                </div>
              </section>
            </Fade>
          </div>
        </div>
        {/* Write contact us form */}
        <div className="container ">
          <div className="content">
            <div className="left-side">
              <div className="phone details">
                <i className="fa fa-phone" aria-hidden="true"></i>
                <div className="topic">Phone</div>
                <div className="text-one">+9476 424 6658</div>
                <div className="text-one">+4917657972131</div>
              </div>
              <div className="email details">
                <i className="fa fa-envelope-o" aria-hidden="true"></i>
                <div className="topic">Email</div>
                <div className="text-one">codingcogs@gmail.com</div>
              </div>
            </div>
            <div className="right-side">
              <div className="topic-text">Send us a message</div>
              <p>
                If you have any work or any queries related to our projects, you
                can send us a message here. It's our pleasure to help you.
              </p>
              <form ref={form} onSubmit={handleSubmit}>
                <div className="input-box">
                  <input
                    name="name"
                    required
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </div>
                <div className="input-box">
                  <input
                    name="email"
                    required
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </div>
                <div className="message-box">
                  <textarea
                    name="message"
                    required
                    rows={10}
                    cols={10}
                    placeholder="Type your message"
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  ></textarea>
                </div>
                <div className="button">
                  <input type="submit" value="Send Now" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer theme={props.theme} />
      <TopButton theme={props.theme} />
    </div>
  );
}
